import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import classnames from 'classnames';
import { BiEventType, BiDataHook } from '@wix/da-bi/pkg/constants';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ThreadPagination from '../../_partials/ThreadPagination';
import { MIN_COMMENT_COUNT_TO_SHOW_BOTTOM_POST } from '../../constants';
import ThreadHeader from '../../_partials/ThreadHeader';
import ThreadPostbox from '../../_partials/ThreadPostbox';
import ThreadStack from '../../_partials/ThreadStack';
import s from './SimpleThread.scss';
const SimpleThread = ({ commentableItemId, commentableTypeId, parentId, parentComment, parentCommentRef, className, postbox, itemCount, maxCommentsShown, statsAndControls, extraInHeader, streamId, allowSelfInit, isFetching, isInfinite, commentComponent, scrollableClassName, commentClassName, commentWrapperClassName, viewRepliesClassName, maxDepthOverride, replyIndentModifier, commentBoxWrapperClassName, threadStackClassName, headerClassName, isSticky, withCommentSuggestions })=>{
    const isTopPostboxVisible = postbox === 'top' || postbox === 'both';
    const isTopmostPostboxVisible = postbox === 'topmost';
    const isBottomPostboxVisible = postbox === 'bottom' || postbox === 'both' && itemCount >= MIN_COMMENT_COUNT_TO_SHOW_BOTTOM_POST;
    const isNotLimitingComments = !maxCommentsShown;
    const postBoxProps = {
        commentableItemId,
        commentableTypeId,
        parentId,
        parentComment,
        isSticky,
        withCommentSuggestions,
        className: commentBoxWrapperClassName
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: className,
        "data-hook": BiDataHook.COMMENTS_THREAD
    }, isTopmostPostboxVisible && /*#__PURE__*/ React.createElement(ThreadPostbox, _object_spread_props(_object_spread({}, postBoxProps), {
        position: "topmost"
    })), statsAndControls !== 'off' && /*#__PURE__*/ React.createElement(ThreadHeader, {
        commentableItemId: commentableItemId,
        commentableTypeId: commentableTypeId,
        parentId: parentId,
        withOrder: [
            'on',
            'order'
        ].includes(statsAndControls),
        withTitle: [
            'on',
            'title'
        ].includes(statsAndControls),
        className: classnames(s['header'], headerClassName)
    }, extraInHeader), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['scrollable'], scrollableClassName)
    }, /*#__PURE__*/ React.createElement("div", null, isTopPostboxVisible && /*#__PURE__*/ React.createElement(ThreadPostbox, _object_spread_props(_object_spread({}, postBoxProps), {
        position: "top"
    })), isNotLimitingComments && /*#__PURE__*/ React.createElement(ThreadPagination, {
        direction: "prev",
        streamId: streamId,
        biData: {
            evid: BiEventType.LOAD_MORE_COMMENTS_CLICK,
            is_load_previous: 1,
            itemid: commentableItemId,
            typeid: commentableTypeId
        }
    }), /*#__PURE__*/ React.createElement(ThreadStack, {
        className: threadStackClassName,
        commentableItemId: commentableItemId,
        commentableTypeId: commentableTypeId,
        parentId: parentId,
        maxCommentsShown: maxCommentsShown,
        commentComponent: commentComponent,
        parentComment: parentComment,
        parentCommentRef: parentCommentRef,
        allowSelfInit: allowSelfInit,
        maxDepthOverride: maxDepthOverride,
        commentClassName: commentClassName,
        commentWrapperClassName: commentWrapperClassName,
        viewRepliesClassName: viewRepliesClassName,
        replyIndentModifier: replyIndentModifier
    }), isFetching && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama"
    }), isNotLimitingComments && /*#__PURE__*/ React.createElement(ThreadPagination, {
        direction: "next",
        className: s['load-more'],
        isInfinite: isInfinite,
        streamId: streamId,
        biData: {
            evid: BiEventType.LOAD_MORE_COMMENTS_CLICK,
            itemid: commentableItemId,
            typeid: commentableTypeId
        }
    }))), isBottomPostboxVisible && /*#__PURE__*/ React.createElement(ThreadPostbox, _object_spread_props(_object_spread({}, postBoxProps), {
        position: "bottom"
    })));
};
SimpleThread.displayName = 'SimpleThread';
export default SimpleThread;
